import LocalCompManager from '@/manager/2.6/LocalCompManager';
import IFeedData from '@/models/comp/IFeedData';
import LocalCompRequest from '@/models/requests/LocalCompRequest';
import CompDataFeedsRequest from '../models/CompDataFeedsRequest';

export default {
    /**
     * Fetches local comp feed data within the store. Currently delegates to the LocalCompManager.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param localCompRequest
     * @returns
     */
    async fetchFeedData(feedRequest: CompDataFeedsRequest): Promise<IFeedData> {
        const localCompRequest: LocalCompRequest = {
            compsGuid: feedRequest.compsGuid,
            qsGuid: feedRequest.qsGuid,
            address: feedRequest.address,
        };

        const feedData = await LocalCompManager.fetchFeedData(localCompRequest);
        return feedData;
    },

    async fetchFeedDataSubComps(feedRequest: CompDataFeedsRequest): Promise<void> {
        const localCompRequest: LocalCompRequest = {
            compsGuid: feedRequest.compsGuid,
            qsGuid: feedRequest.qsGuid,
            address: feedRequest.address,
        };

        await LocalCompManager.fetchFeedDataSubComps(localCompRequest);
    },
};
